// Load only JS from Node Modules
import "owl.carousel";
import "lightgallery";
import "lightgallery/modules/lg-thumbnail";
import "lightgallery/modules/lg-zoom";
import "lightgallery/modules/lg-fullscreen";
import "bootstrap";
// import "@fortawesome/fontawesome-free";
